export const PMAX_WIZARD_ID_NAME = {
  PMAX_NORTH_STAR_SETTING_WIZARD: 'perf-max-north-star-setting-wizard',
  PMAX_NORTH_STAR_WIZARD: 'perf-max-north-star-wizard',
};
